export const TypesDevices = {
    MOBILE: 'MOBILE',
    DESKTOP: 'DESKTOP'
} as const;
